function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_14149_471560)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.6499 6.65002V19.77",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.55 6.65002V19.77",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.74989 12.44C6.91521 12.44 7.85989 11.4953 7.85989 10.33C7.85989 9.16465 6.91521 8.21997 5.74989 8.21997C4.58457 8.21997 3.63989 9.16465 3.63989 10.33C3.63989 11.4953 4.58457 12.44 5.74989 12.44Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.8699 17.07V13.77H1.6499V17.54H7.9299C7.8899 17.39 7.8699 17.24 7.8699 17.07Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.4599 13.77V17.07C19.4599 17.23 19.4399 17.39 19.3999 17.54H21.5499V13.77H19.4599V13.77Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4601 8.73999H9.87012C8.76555 8.73999 7.87012 9.63542 7.87012 10.74V17.07C7.87012 18.1746 8.76555 19.07 9.87012 19.07H17.4601C18.5647 19.07 19.4601 18.1746 19.4601 17.07V10.74C19.4601 9.63542 18.5647 8.73999 17.4601 8.73999Z",
  stroke: "white",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_14149_471560"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.2,
  height: 14.42,
  fill: "white",
  transform: "translate(1 6)"
})));

var SvgPatient = function SvgPatient(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPatient, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/patient.186ee4ed.svg";
export { ForwardRef as ReactComponent };